import React, { forwardRef } from 'react'

import { Icon, Link, IconButton, Alert as CommonAlert } from '@popmenu/common-ui'
import { Info, Error as ErrorIcon, X as XIcon, Warning, CheckCircle } from '@popmenu/web-icons'
import { LinkProps } from '@material-ui/core'
import { useAlertStyles } from './AlertStyles'
import { AlertProps } from './AlertProps'

const severityIcons: Record<Extract<AlertProps, 'severity'>, string> = {
  info: Info,
  error: ErrorIcon,
  warning: Warning,
  success: CheckCircle,
}

const getLinkProps = (link: AlertProps['link']): Pick<LinkProps, 'children' | 'href' | 'onClick'> | null => {
  if (!link) return null

  const { href, onClick, text } = link

  if (!text) return null

  const props = { children: text }

  if (href) return { ...props, href }
  if (onClick) return { ...props, onClick }

  return null
}

export const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  const { children, link, severity = 'error', variant = 'outlined', onClose, ...muiProps } = props
  const classes = useAlertStyles(props)
  const validLink = link && getLinkProps(link)
  const Action = (
    <React.Fragment>
      {validLink && <Link {...validLink} />}
      {onClose && (
        <IconButton onClick={onClose}>
          <Icon icon={XIcon} />
        </IconButton>
      )}
    </React.Fragment>
  )

  return (
    <CommonAlert
      ref={ref}
      classes={classes}
      // @ts-expect-error - todo.
      icon={<Icon icon={severityIcons[severity]} size="extra-large" />}
      action={Action}
      variant={variant}
      severity={severity}
      {...muiProps}
    >
      {children}
    </CommonAlert>
  )
})

Alert.displayName = 'Alert'
